import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/StudentsPage.css';
import { FaEye, FaEdit, FaRegEdit  } from 'react-icons/fa';
import { BsPiggyBank } from "react-icons/bs";

const StudentListPage = () => {
    const [branchList, setBranchList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [students, setStudents] = useState([]);
    const [searchName, setSearchName] = useState('');
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [age, setAge] = useState('');
    const [religion, setReligion] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);

    // Fetch branch list when component mounts
    useEffect(() => {
        const fetchBranchList = async () => {
            try {
                const response = await api.get('/utils/getBranchList');
                const branches = response.data.data.branchList.map(branch => ({
                    id: branch.branch_id,
                    name: `${branch.branch_code} - ${branch.branch_name}`,
                }));
                setBranchList(branches);
            } catch (error) {
                console.error("Failed to fetch branch list", error);
            }
        };

        const fetchStatusList = async () => {
            try {
                const response = await api.get('/utils/getStudentStatusList');
                const statuses = response.data.data.statusList.map(status => ({
                    id: status.status_id,
                    name: `${status.status_name}`,
                }));
                setStatusList(statuses);
            } catch (error) {
                console.error("Failed to fetch status list", error);
            }
        };

        fetchStatusList();
        fetchBranchList();
        
    }, []);

    useEffect(() => {
        if (isSearched) {
            handleSearch(); // Fetch students when currentPage changes
        }
    }, [currentPage, isSearched]);

    // Fetch students based on filter when search is clicked
    const handleSearch = async () => {
        try {
            const response = await api.post('/student/getStudentListByFilter', {
                data: [{
                    student_name: searchName,
                    branch_id: selectedBranch,
                    status_id: selectedStatus,
                    age: age,
                    religion: religion,
                }],
                limit: 25, // Membatasi data per halaman menjadi 25
                page: currentPage // Mengirim halaman saat ini ke backend
            });
            setStudents(response.data.data.studentList);
            setTotalData(response.data.data.totalCount); // Total data tanpa pagination
            setTotalPages(Math.ceil(response.data.data.totalCount / 25)); // Menghitung total halaman berdasarkan total data


            const totalCount = response.data.data.totalCount;
            //alert(totalCount);
            if (totalCount > 0) {
               // alert("masuk1 ");
                setTotalPages(Math.ceil(totalCount / 25));
                //alert(totalPages);
                //alert(currentPage);
                if(totalPages < currentPage){
                    //alert("masuk2 ");
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch students", error);
        }
    };
    

    // Handle pagination
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleViewDetails = (studentId) => {
        navigate(`/student/detail/${studentId}`);
    };

    
    const handleEditDetails = (studentId) => {
        navigate(`/student/program/edit/${studentId}`);
    };

    const handleEditStatusDetails = (studentId) => {
        navigate(`/student/status/edit/${studentId}`);
    };

    const handleStudentSavingsCreate = (studentId) => {
        navigate(`/student/saving/create/${studentId}`);
    };

    // Refetch students whenever the page changes
    //useEffect(() => {
    //    if (currentPage > 0) {
    //        handleSearch();
    //    }
    //}, [currentPage]);

    return (
        <div className="students-page">
            <div className="page-title">Kidola Student List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Student Name</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Enter student name"
                                            value={searchName}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Branch</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedBranch}
                                            onChange={(e) => setSelectedBranch(e.target.value)}
                                        >
                                            <option value="">Select Branch</option>
                                            {branchList.map(branch => (
                                                <option key={branch.id} value={branch.id}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Status</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedStatus}
                                            onChange={(e) => setSelectedStatus(e.target.value)}
                                        >
                                            <option value="">Select Status</option>
                                            {statusList.map(status => (
                                                <option key={status.id} value={status.id}>
                                                    {status.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Age</label>
                                    </td>
                                    <td>
                                        <select
                                            value={age}
                                            onChange={(e) => setAge(e.target.value)}
                                        >
                                            <option value="">Select Age</option>
                                            <option value="4-6">4 - 6</option>
                                            <option value="6-8">6 - 8</option>
                                            
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Religion</label>
                                    </td>
                                    <td>                              
                                        <select
                                            value={religion}
                                            onChange={(e) => setReligion(e.target.value)}
                                        >
                                            <option key="" value="">Select Religion</option>
                                            <option key="Christian" value="Christian">Christian</option>
                                            <option key="Islam" value="Islam">Islam</option>
                                            <option key="Catholic" value="Catholic">Catholic</option>
                                            <option key="Confucius" value="Confucius">Confucius</option>
                                            <option key="Buddha" value="Buddha">Buddha</option>
                                            <option key="Hindu" value="Hindu">Hindu</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="students-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th>Student Name</th>
                                    <th>Age</th>
                                    <th>Branch</th>
                                    <th>Religion</th>
                                    <th>Program</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {students.map((student, index) => (
                                    <tr key={student.student_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * 25}</td>
                                        <td>{student.student_name}</td>
                                        <td>{student.age}</td>
                                        <td>{student.Branch.branch_name}</td>
                                        <td>{student.religion? student.religion : '-'}</td>
                                        <td>{student.StudentLevels.map(level => level.mainProgram.program_name).join(', ')}</td>
                                        <td>{student.StudentStatuses.map(status => status.Status.status_name).join(', ')}</td>
                                        <td>
                                            <FaEye className="action-icon" title="View Details" onClick={() => handleViewDetails(student.student_id)} />
                                            <FaEdit className="action-icon" title="Edit Student Program" onClick={() => handleEditDetails(student.student_id)} />
                                            <FaRegEdit className="action-icon" title="Edit Student Status" onClick={() => handleEditStatusDetails(student.student_id)} />
                                            <BsPiggyBank className="action-icon" title="Student Savings Create" onClick={() => handleStudentSavingsCreate(student.student_id)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                    <div className="pagination">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            Prev
                                        </button>
                                    </td>
                                    <td>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </td>
                                    <td>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentListPage;
